<template lang="pug">
  Auth(@loggedIn="onLoggedIn" @loginFailed="loginFailed")
    NowLoading(:show="showNowLoading")
    div.wrap-sign-ui.f.fh
      div.sign-ui
        //- div.wrap-title.f.fc.mb30
          span(v-if="avatar").wrap-avatar
            div.wrap-icon.f.fh.mb12
              img(:src="avatar.iconURL")
            span {{`サインアップして${avatar.typeName}${avatar.num + 1}号になりましょう！`}}
          span(v-else).welcome ミンナアイへようこそ！
        div.wrap-title
          div(v-if="avatar").wrap-profile.f.fc
            div
              div.wrap-img.f.fh.mb24
                img(:src="avatar.iconURL")
              div.f.fc
                div.wrap-message.px12.py12.mb20
                  span(v-if="$route.name === 'sign-up'").message ミンナになってくれる？
                  span(v-if="$route.name === 'sign-in'").message おかえりミンナ

        div.wrap-sign-in-ui.mb24
          SignIn(@signInSuccess="onLoggedIn")
        
        div.wrap-select-sign-in-up.f.fc
          span(v-if="$route.name === 'sign-up'" @click="$router.push('/sign-in')") サインイン
          span(v-if="$route.name === 'sign-in'" @click="$router.push('/sign-up')") サインアップ
</template>

<style lang="scss" scoped>
.wrap-sign-ui {
  width: 100%;
  height: 100vh;
  .sign-ui {
    width: 92%;
    margin: 0 auto;
    max-width: 620px;
    .wrap-title {
      // .wrap-avatar {
      //   .wrap-icon {
      //     width: 120px;
      //     min-height: 120px;
      //     margin: 0 auto;
      //     overflow: hidden;
      //     border-radius: 50%;
      //     border: solid 1px rgba(0, 0, 0, 0.2);
      //   }
      //   span {
      //     display: block;
      //     font-size: 12px;
      //   }
      // }
      // .welcome {
      //   font-weight: bold;
      // }
      .wrap-img {
        width: 160px;
        height: 160px;
        border-radius: 50%;
        border: solid 1px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        img {
          object-fit: cover;
        }
      }
      .wrap-message {
        max-width: 320px;
        position: relative;
        margin: 0 auto;
        display: inline-block;
        background: #fff;
        border-radius: 9px;
        border: solid rgba(0, 0, 0, 0.1) 1px;
        .message {
          display: block;
          font-size: 12px;
          font-weight: bold;
        }
      }
      /* 吹き出しのスタイル */
      .wrap-message:before,
      .wrap-message:after {
        position: absolute;
        left: 50%;
        top: 1px;
        border: solid transparent;
        content: "";
        height: 0;
        width: 0;
        border-width: 14px;
        margin: 0 0 0 -14px;
        transform: rotate(180deg) translateY(28px);
      }
      .wrap-message:before {
        border-top-color: #000000;
      }
      .wrap-message:after {
        border-top-color: #ffffff;
      }
    }
    .wrap-sign-in-ui {
      min-height: 144px;
    }
    .wrap-select-sign-in-up {
      span {
        font-size: 12px;
        color: #4285f4;
      }
    }
  }
}
</style>

<script>
import db, { firebase } from '@/components/utils/firebase'

import { createNamespacedHelpers } from 'vuex'

import Auth from '@/components/auth'
import SignIn from '@/components/sign-in/firebase-sign-in-ui'
import NowLoading from '@/components/common/NowLoading'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  components: {
    Auth,
    SignIn,
    NowLoading
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    resultRedirect: null,
    redirectUrl: null,
    avatar: null,
    showNowLoading: true
  }),
  computed: {
    ...mapStateAuth(['isLoggedIn', 'uid', 'isAnonymous'])
  },
  async created () {
    this.avatar = await db.collection('avatars').doc('minna_ai').get().then((d) => { return d.data() })
    // if (this.id !== '') {
    //   this.avatar = await db.collection('avatars').doc(this.id).get().then((d) => { return d.data() })
    // }
  },
  mounted () {
    // setTimeout(() => {
    //   if (location.pathname.split('/')[1] === 'sign-up') {
    //     document.getElementsByClassName('firebaseui-title')[0].innerText = 'Sign Up with Email'
    //   }
    // }, 300)
    if (this.uid && !this.isAnonymous) this.$router.push(`/avatar/minna_ai`)
  },
  methods: {
    loginFailed () {
      this.showNowLoading = false
    },
    async onLoggedIn () {
      this.showNowLoading = false

      await this.sleepByPromise(0.8)
      var firebaseUser = await firebase.auth().currentUser
      console.log('firebaseUser:', firebaseUser)

      if (this.uid && !this.isAnonymous) {
        this.showNowLoading = true

        var user = await firebase.auth().currentUser
        var userDoc = await db.collection('users').doc(this.uid).get()

        if (!userDoc.exists) {
          var avatar = await db.collection('avatars').doc('minna_ai').get().then((e) => { return e.data() })

          var userObj = {
            uid: user.uid,
            // name: user.displayName,
            // email: user.email,
            avatar: 'minna_ai',
            avatars: ['minna_ai'],
            name: `${avatar.typeName}${avatar.num}号`,
            profile: 'No Profile',
            // iconURL: user.photoURL,
            lastSignInTime: user.metadata.lastSignInTime,
            createdAt: user.metadata.creationTime,
            alikePoint: 0,
            unlikePoint: 0,
            likePoint: 0,
            retweetPoint: 0,
            postPoint: 0
          }

          // userObj.iconURL = 'https://firebasestorage.googleapis.com/v0/b/minna-ai.appspot.com/o/public%2Fminna_ai.png?alt=media&token=70fe4fed-5c48-491c-9722-f7c041c9c117'
          userObj.iconURL = '/img/avatar-main.png'

          await db.collection('users')
            .doc(user.uid)
            .set(userObj)
            .then(function () {
              console.log('Document successfully written!')
            })
            .catch(function (error) {
              console.error('Error writing document: ', error)
            })

          var emailObj = {
            author: user.uid,
            email: user.email
          }

          await db.collection('users')
            .doc(user.uid)
            .collection('secrets')
            .doc('email')
            .set(emailObj)
            .then(function () {
              console.log('Document successfully written!')
            })
            .catch(function (error) {
              console.error('Error writing document: ', error)
            })
        } // if (!userDoc.exists)

        if (this.redirectUrl && this.redirectUrl.signInMethod === 'twitter.com') {
          var token = {
            author: user.uid,
            token: [{
              avatar: 'minna_ai',
              accessToken: this.redirectUrl.accessToken,
              secret: this.redirectUrl.secret
            }]
          }

          await db.collection('users')
            .doc(user.uid)
            .collection('secrets')
            .doc('access_token')
            .set(token)
        }

        this.showNowLoading = false

        // this.$router.push(`${this.resultRedirect}`)

        this.$router.push(`/avatar/minna_ai`)
        // if (!this.resultRedirect || this.$route.name.indexOf('sign-up')) this.$router.push(`/avatar/minna_ai`)
      } // if (this.uid && !this.isAnonymous) {
    },
    signInSuccess (redirectUrl) {
      this.redirectUrl = redirectUrl
      // this.onLoggedIn()
    },
    sleepByPromise (sec) {
      return new Promise(resolve => setTimeout(resolve, sec * 1000))
    }
  }
}
</script>
